export default __webpack_public_path__ + "static/media/friendly_support.838d2814.svg";